<section class="invoice-create-success">
    <div class="success-card">
        <div class="icon-badge" aria-hidden="true">
            <i class="fas fa-check"></i>
        </div>
        <h1>{{ 'Rechnungserstellung erfolgreich' | translate }}</h1>

        @if (loadingInvoice()) {
            <p class="muted">{{ 'Details werden geladen...' | translate }}</p>
        } @else if (loadError()) {
            <p class="error">{{ 'Rechnungsdetails konnten nicht geladen werden.' | translate }}</p>
        } @else {
            <p class="subtitle">
                {{ 'Rechnung {{number}} wurde erfolgreich angelegt.' | translate: { number: invoiceNumber() } }}
            </p>
        }

        <div class="meta">
            <span class="label"></span>
        </div>
    </div>

    <div class="action-grid">
        @if (permissions().canViewReceipts) {
            <button
                class="btn btn-outline-secondary btn-lg w-100 text-start"
                class="btn btn-outline-secondary btn-lg w-100 text-start action-button"
                type="button"
                [routerLink]="['/', View.CLIENT, 'my-admin', 'receipt', 'list']"
            >
                <div class="action-title">{{ 'Zur Lieferscheinliste' | translate }}</div>
            </button>
        }

        @if (permissions().canViewInvoices) {
            <button
                class="btn btn-outline-secondary btn-lg w-100 text-start action-button"
                type="button"
                [routerLink]="['/', View.CLIENT, 'my-admin', 'invoice', 'list']"
            >
                <div class="action-title">{{ 'Gehe zur Rechnungsliste' | translate }}</div>
            </button>
        }

        @if (detailLinkAllowed()) {
            <button
                class="btn btn-primary btn-lg w-100 text-start action-button"
                type="button"
                [routerLink]="['/', View.CLIENT, 'my-admin', 'invoice', invoiceId(), 'detail']"
            >
                <div class="action-title">{{ 'Zur Rechnungsdetailseite' | translate }}</div>
            </button>
        }
    </div>

    @if (!permissionsLoading() && !hasAnyLink()) {
        <div class="no-links">
            {{ 'Keine Navigationsoptionen für Ihre Berechtigungen verfügbar.' | translate }}
        </div>
    }
</section>
